<template>
    <div class="cdi_textarea object_detail form_control_textarea" :title="field.label">
        <label :class="`${(hasPermission) ? 'cdi_edit' : ''}`" @click="toggleField">{{ field.label }}</label>
        <textarea class="form-control form_control_textarea" ref="detailInput" v-model="localVal" v-show="isActive"></textarea>
        <div class="form-control" v-show="!isActive">{{ val }}</div>
    </div>
</template>

<script>
export default {
    name: "DetailsTextarea",
    props: ['field', 'val'],
    data() {
        return {
            isActive: false,
            localVal: '',
        }
    },
    methods: {
        toggleField: function() {
            if (this.hasPermission) {
                this.isActive = !this.isActive;
                if (this.isActive){
                    this.$nextTick(() => this.$refs.detailInput.focus());
                }
                if (this.localVal != this.val){
                    this.save();
                }
            }
        },
        save: function() {
            this.$emit('save', {'field': this.field.name, 'val': this.localVal});
            this.isActive = false;
        }
    },
    watch: {
        val: function (){
            this.localVal = this.val;
        }
    },
    computed: {
        hasPermission: function () {
            if (this.field.permission === undefined) {
                return true;
            } else {
                return this.field.permission;
            }
        }
    }
}
</script>

<style scoped>
    textarea {
        resize: vertical;
    }
    .form-control {
        white-space: pre-wrap;
    }
</style>